.global-event-listener-root {
  align-items: inherit;
  display: inherit;
  flex-direction: inherit;
  height: inherit;
  justify-content: inherit;
  width: inherit;

  &:focus {
    outline: none;
  }
}
